import React, { useEffect } from "react"
// react hook form
import { Controller } from "react-hook-form"
// react phone input
import "react-phone-input-2/lib/style.css"
// components
import { InputWithLabel } from "@components/Form"
import { MailIcon } from "@assets/icons"
import PhoneInput from "react-phone-input-2"
import ArrowRightInsideCircle from "@assets/icons/arrowRightInsideCircle"
import usePatient from "@hooks/usePatient"
import { useDispatch, useSelector } from "react-redux"
import { Button } from "@components/Button"
import { findPatientSuccess } from "@redux/slices/patientSlice"
import { notify } from "src/utils/notify"
// assets

export const IndividualInfo = ({ control, errors, reset }) => {
  const { handleFindPatient } = usePatient()
  const dispatch = useDispatch()
  const { findPatientData, isFindPatientLoading } = useSelector(
    (state) => state.patient
  )

  function validateEmail(email) {
    const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/
    return emailRegex.test(email)
  }

  useEffect(() => {
    if (findPatientData) {
      reset(findPatientData.data)
    }
    return () => {
      dispatch(findPatientSuccess(null))
    }
  }, [findPatientData])

  return (
    <>
      <div className="w-full md:max-w-[20.12rem] gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
        <h2 className="text-xs font-medium text-[--text-light-gray]">
          INDIVIDUAL INFO
        </h2>
        {/* Email */}
        <InputWithLabel
          label="Email"
          name="email"
          rules={{
            required: "Email is required",
          }}
          placeholder="johndoe@gmail.com"
          control={control}
          errors={errors}
          inputClassName="!pl-10 bg-[#EFF0F0]"
          isRequired
          type="email"
          customInput={
            <div className="relative flex items-center rounded-md">
              <Controller
                control={control}
                name="email"
                rules={{
                  required: "email is required",
                }}
                render={({ field: { value, onChange, ref } }) => (
                  <div className="flex gap-2 items-center shadow-[0px_1px_2px_0px_#1018280D] w-full">
                    <MailIcon className="absolute left-3.5 h-5 w-5 text-[var(--text-secondary)]" />
                    <input
                      id="email"
                      type="email"
                      name="email"
                      class="rounded-lg text-base py-2.5 px-3.5 border border-[#D6EBFF] flex items-center h-full w-full !pl-10"
                      placeholder="johndoe@gmail.com"
                      onChange={onChange}
                      ref={ref}
                    ></input>
                    <Button
                      className="px-3 py-2 !bg-[--primary-blue-light] absolute right-0"
                      variant="transparent"
                      onClick={() => {
                        if (validateEmail(value)) {
                          handleFindPatient({ email: value })
                        } else {
                          notify("invalid email", "error")
                        }
                      }}
                      loading={isFindPatientLoading}
                      disabled={isFindPatientLoading}
                    >
                      {!isFindPatientLoading ? (
                        <ArrowRightInsideCircle className="text-[#1849D6]" />
                      ) : null}
                    </Button>
                  </div>
                )}
              />
            </div>
          }
        />
        <InputWithLabel
          label="Contact"
          name="contact"
          rules={{
            required: "Contact is required",
          }}
          placeholder="0000000000"
          control={control}
          errors={errors}
          customInput={
            <Controller
              control={control}
              name="contact"
              rules={{
                required: "Contact is required",
              }}
              render={({ field: { value, onChange } }) => (
                <PhoneInput
                  disabled
                  country={"us"}
                  value={value}
                  onChange={onChange}
                  autoFormat
                  inputProps={{
                    placeholder: "0000000000",
                    className: `h-11 !w-full !pl-12 focus:outline-none rounded-lg border border-[--primary-blue] ${errors.contact ? "border-[var(--border-error)]" : ""} focus:border-[--primary-blue] border-0`,
                  }}
                  buttonClass="bg-[#EFF0F0] !border-none !rounded-lg !top-1.5 !bottom-1.5 !left-1"
                  containerStyle={{
                    width: "100%",
                    border: "none",
                  }}
                  inputStyle={{
                    borderRadius: "8px",
                    backgroundColor: "#EFF0F0",
                  }}
                />
              )}
            />
          }
          isRequired
        />
        <div className="flex justify-between gap-3 md:gap-5">
          {/* First Name */}
          <InputWithLabel
            label="First Name"
            name="firstName"
            rules={{
              required: "First name is required",
              pattern: {
                value: /^[a-zA-Z0-9]*$/,
                message: "First name must be alphanumeric",
              },
              minLength: {
                value: 1,
                message: "First name must be at least 1 character",
              },
              maxLength: {
                value: 30,
                message: "First name must be at most 30 characters",
              },
            }}
            placeholder="First Name"
            control={control}
            errors={errors}
            containerClassName="w-1/2"
            isRequired
            inputClassName="bg-[#EFF0F0] border-0"
            disabled={true}
          />
          {/* Last Name */}
          <InputWithLabel
            label="Last Name"
            name="lastName"
            rules={{
              required: "Last name is required",
              pattern: {
                value: /^[a-zA-Z0-9]*$/,
                message: "Last name must be alphanumeric",
              },
              minLength: {
                value: 1,
                message: "Last name must be at least 1 character",
              },
              maxLength: {
                value: 30,
                message: "Last name must be at most 30 characters",
              },
            }}
            placeholder="Last Name"
            control={control}
            errors={errors}
            containerClassName="w-1/2"
            isRequired
            inputClassName="bg-[#EFF0F0] border-0"
            disabled={true}
          />
        </div>
      </div>
    </>
  )
}

export default IndividualInfo
